import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

export interface IntentRequestData {
  title: string;
  file_ids: string[];
  intent_metadata: Record<string, any>;
  pipeline_type: string;
}

export interface SingleIntentRequest {
  id: string;
  requestData: IntentRequestData;
}

export type UserIntentRequest = SingleIntentRequest | SingleIntentRequest[];

/**
 * Updates a single intent
 */
const updateSingleIntent = async ({ id, requestData }: SingleIntentRequest) => {
  const response = await axios.patch(`/intents/${id}`, requestData);
  return response.data;
};

/**
 * Updates multiple intents
 */
const updateMultipleIntents = async (requests: SingleIntentRequest[]) => {
  const updatePromises = requests.map((request) => updateSingleIntent(request));
  return Promise.all(updatePromises);
};

/**
 * Updates user intent(s) based on the input
 */
const updateUserIntent = async (data: UserIntentRequest) => {
  if (Array.isArray(data)) {
    return updateMultipleIntents(data);
  }
  return updateSingleIntent(data);
};

/**
 * React Query hook for updating a user intent or multiple intents
 */
export function useUpdateUserIntent() {
  const { mutate } = useMutation({
    mutationFn: updateUserIntent,
  });

  return { updateUserIntent: mutate };
}
